var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},[_c('woot-tabs',{attrs:{"index":_vm.activeTab,"border":false},on:{"change":_vm.onTabChange}},_vm._l((_vm.tabs),function(item){return _c('woot-tabs-item',{key:item.key,attrs:{"name":item.name,"count":item.count}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }